import { FC } from 'react';
import {
  PrototypeStatus,
  PrototypeStatusBadge,
} from '@agilelab/plugin-wb-system-prototype-common';
import { WbBadgeProps } from '@agilelab/plugin-wb-platform';

type StatusBadgeProps = {
  status: PrototypeStatus;
} & WbBadgeProps;

export const StatusBadge: FC<StatusBadgeProps> = props => {
  return <PrototypeStatusBadge {...props} />;
};
